import { render, staticRenderFns } from "./Gameplay.vue?vue&type=template&id=27662df7&"
import script from "./Gameplay.vue?vue&type=script&lang=js&"
export * from "./Gameplay.vue?vue&type=script&lang=js&"
import style0 from "./Gameplay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports